import { Box, IconButton, Modal, Typography } from '@mui/material'
import { Clear } from '@mui/icons-material'
import React, { useContext } from 'react'
import { SignatureModalStyles } from './SignatureModalStyles'
import { LanguageContext } from '../../../utilities/contexts/LanguageContext'
import language from '../../../language/language'

type SignatureModalProps = {
  isVisible: boolean
  closeCallback: () => void
  storeNumber: string
  printName: string
  signatureImage: string
}

//TODO: Style, get signature working
export const SignatureModal = ({
  isVisible,
  closeCallback,
  storeNumber,
  printName,
  signatureImage
}: SignatureModalProps) => {
  const { currentLanguage } = useContext(LanguageContext)
  return (
    <Modal open={isVisible} sx={SignatureModalStyles.modal}>
      <Box sx={SignatureModalStyles.container}>
        <Box sx={SignatureModalStyles.header}>
          <Typography sx={SignatureModalStyles.titleText}>
            {language[currentLanguage].signature}
          </Typography>
          <IconButton onClick={closeCallback}>
            <Clear fontSize="medium" />
          </IconButton>
        </Box>
        <Typography sx={SignatureModalStyles.body}>
          {language[currentLanguage].storeString}: {storeNumber}
        </Typography>
        <Typography sx={SignatureModalStyles.bodyText}><span>Signed by: {printName}</span></Typography>
        <img style={SignatureModalStyles.image} src={signatureImage} alt={'signature'} />
      </Box>
    </Modal>
  )
}
